var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-title"},[_c('span',[_vm._v(_vm._s(_vm.title ? _vm.title : _vm.getMenuTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }